import React from 'react'

export const NoDataFound = ({ text }) => {
    return (
        <div className='nodata-found-container'>
            <p>{text || 'No Data Found'}</p>
        </div>
    )
}